import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { DialogBase, DialogOptions } from '@marmon/frontend/common';
import { TuiButton } from '@taiga-ui/core';

type InformationOptions = {
	description: string;
	translationParams?: object;
};

@Component({
	standalone: true,
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [TranslocoModule, TuiButton],
	selector: 'mar-information-dialog',
	templateUrl: 'information-dialog.component.html',
})
export class InformationDialogComponent extends DialogBase<
	boolean,
	InformationOptions
> {
	static override readonly DialogOptions = {
		size: 's',
	} as DialogOptions;

	readonly acceptText = 'action.ok';

	readonly onAccept = () => this.context.completeWith(true);
}
